import { Dropdown } from "react-bootstrap"
import useDropdown from "../../../hooks/dropdown.hook";
import './my-dropdown.styles.scss';
import { createContext, useContext, useEffect } from "react";

const DropdownContext = createContext(null);

/**
 * MyDropdown component
 * @deprecated Use MyDropdownNewComponent instead
 * 
 * @param {Object} props
 * @param {string} props.className
 * @param {string} props.toggleClassName
 * @param {string} props.menuClassName
 * @param {function} props.onToggle
 * @param {React.Component} props.toggleComponent
 * @param {React.Component} props.children
 * @param {object} props.popperConfig
 * @param {function} props.isOpenUpdate
 * @param {React.RefObject} props.refBtn
 * @param {React.RefObject} props.refMenu
 * @param {boolean} props.renderOnMount
 * @returns {React.Component}
 * @example
 * <MyDropdown
      toggleComponent={(
        <div className="f-black">
          Menu
        </div>
      )}
      dropdownClassName="ml-3"
    >
      <MyDropdown.Item>
        Item 1
      </MyDropdown.Item>
      <MyDropdown.Item>
        Item 2
      </MyDropdown.Item>
      <MyDropdown.Item>
        Item 3
      </MyDropdown.Item>
    </MyDropdown>
 */
const MyDropdownOld = ({
  className = "",
  toggleClassName = "",
  menuClassName = "",
  onToggle = () => { },
  toggleComponent,
  children,
  popperConfig,
  isOpenUpdate = () => { },
  refBtn,
  refMenu,
  setRefBtn = () => {},
  renderOnMount = false,
  ...rest
}) => {
  const { isOpen, refBtn: curRefBtn, refMenu: curRefMenu, setIsOpen } = useDropdown({ 
    disableClickOutside: false,
    defaultRefBtn: refBtn,
    defaultRefMenu: refMenu
  });

  useEffect(() => {
    setRefBtn(curRefBtn);
  }, [curRefBtn]);

  useEffect(() => {
    onToggle(isOpen);
  }, [isOpen]);
  
  return (
    <DropdownContext.Provider value={{ setIsOpen }}>
      <Dropdown
        {...rest}
        className={`transparennt-wrapper-dropdown my-dropdown my-dropdown-common ${className}`}
        onToggle={() => {
          setIsOpen(prev => !prev);
          isOpenUpdate(!isOpen);
        }}
        show={isOpen}
      >
        <Dropdown.Toggle ref={curRefBtn} className={toggleClassName}>
          {toggleComponent}
        </Dropdown.Toggle>
        <Dropdown.Menu popperConfig={popperConfig} ref={curRefMenu} className={`menu ${menuClassName}`} renderOnMount={renderOnMount}>
          {children}
        </Dropdown.Menu>
      </Dropdown>
    </DropdownContext.Provider>
  )
}

const MyDropdownItem = ({ className, children, closeOnClick = true, disabled, ...props }) => {
  const { setIsOpen } = useContext(DropdownContext);

  return (
    <div 
      {...props} 
      className={`item ${className ?? ''} ${disabled ? 'disabled' : ''}`} 
      onClick={(e) => {
        if (disabled) return
        if (closeOnClick) {
          setIsOpen(false);
        }
        if (props.onClick) {
          props.onClick(e);
        }
      }}
    >
      {children}
    </div>
  );
};

/**
 * MyDropdown.Item component
 * 
 * @param {Object} props
 * @param {string} className
 * @param {Function} onClick
 * @param {boolean} closeOnClick
 * @param {boolean} disabled
 * @param {React.Component} children
 * @returns {React.Component}
 */
MyDropdownOld.Item = MyDropdownItem;

export default MyDropdownOld;
